<template>
	<el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :visible.sync="dialogVisible" destroy-on-close title="下载说明" width="620px">
		<div>
			<el-form @submit.native.prevent ref="formRef" :model="form" :rules="rules" label-position="top" label-width="120px">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item label="" label-width="2px">
							<p style="margin: 0;line-height: 26px;color: rgb(96, 98, 102);">温馨提示：</p>
							<p style="margin: 0;line-height: 26px;color: rgb(96, 98, 102);">（1）为保障作者权益，系统将为PDF添加专属水印。此文件仅限您个人使用，请勿传播。</p>
							<p style="margin: 0;line-height: 26px;color: rgb(96, 98, 102);">（2）PDF文件设有打开密码，请输入您账户预留的手机号进行验证。</p>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="请选择水印类型：" prop="waterType">
							<el-radio-group v-model="form.waterType">
								<el-radio :label="0">个人</el-radio>
								<el-radio :label="1">公司</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>

					<el-col :span="24">
						<el-form-item label="水印内容：下面数字是用户ID" prop="watermarkUser" v-if="form.waterType === 0">
							<!-- <div slot="label" style="display: flex;align-items: center;">

							</div>	 -->
							<el-input v-model.trim="form.watermarkUser" placeholder="请输入水印内容" disabled />
						</el-form-item>
						<el-form-item label="水印内容：下面内容请从发票抬头中选择" prop="watermarkCompany" v-if="form.waterType === 1">
							<el-select v-model="form.watermarkCompany" placeholder="请选择" v-if="companyList.length > 0" style="width: 100%">
								<el-option v-for="item in companyList" :key="item.invoiceTitle" :label="item.invoiceTitle" :value="item.invoiceTitle" />
							</el-select>
							<div v-else class="flex" style="align-items: center">
								<p>暂无发票抬头信息，请先添加</p>
							</div>
							<el-button size="mini" type="primary" plain @click="getMemberGetInvoice" style="margin-top: 18px">刷新数据</el-button>
							<el-button size="mini" type="primary" plain @click="handleAddCompany" style="margin-left: 18px">添加发票抬头</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">关闭</el-button>
				<el-button size="small" type="primary" @click="handleConfirm"> 提交 </el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
import TMessage from '@/utils/TMessage';
import { mapGetters } from 'vuex';
import { getMemberGetInvoice } from '@/api/user/invoice.js';
export default {
	name: 'DialogWatermark',
	data() {
		return {
			dialogVisible: false,
			form: {
				watermarkUser: '',
				watermarkCompany: '',
				waterType: 0,
				watermark: ''
			},
			rules: {
				waterType: [{ type: 'number', required: true, message: '请选择水印类型', trigger: 'change' }],
				watermarkUser: [{ required: true, message: '请输入水印内容', trigger: 'blur' }],
				watermarkCompany: [{ required: true, message: '请选择发票抬头', trigger: 'change' }]
			},
			companyList: []
		};
	},
	watch: {
		'form.waterType'(newVal, oldVal) {
			if (newVal === 0 && oldVal) {
				this.form.watermarkUser = this.uinfo.consumerCode;
				this.form.watermarkCompany = '';
				this.resetForm();
			} else {
				this.getMemberGetInvoice();
				this.form.watermarkCompany = '';
			}
		},
		dialogVisible: {
			handler(newVal, oldVal) {
				if (!newVal) {
					this.resetForm();
				} else {
					this.$nextTick(() => {
						this.form.watermarkUser = this.uinfo.consumerCode;
						this.form.watermarkCompany = '';
						this.getMemberGetInvoice();
					});
				}
			},
			deep: true
		}
	},
	computed: {
		...mapGetters('User', ['uinfo'])
	},
	methods: {
		//获取发票信息
		getMemberGetInvoice() {
			getMemberGetInvoice().then(res => {
				if (res.code === 200) {
					this.companyList = res.data.rows;
				}
			});
		},

		handleAddCompany() {
			const targetRoute = this.$router.resolve({
				path: '/UserCenter/UserInvoice'
			});
			window.open(targetRoute.href, '_blank');
			// this.$router.push({
			//     path: '/index/UserCenter/UserInvoice'
			// });
		},

		resetForm() {
			this.$refs['formRef'].resetFields();
		},

		handleConfirm() {
			this.$refs['formRef'].validate(valid => {
				if (valid) {
					if (this.form.waterType === 0) {
						this.form.watermark = this.form.watermarkUser;
					} else {
						this.form.watermark = this.form.watermarkCompany;
					}

					this.$emit('confirmInfo', this.form);
				}
			});
		}
	}
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header {
	border-bottom: 1px solid #e8e8e8;
	margin-right: 0;
	background: #f5f7fa;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
	color: #3a434f;
	font-size: 24px;
}

/deep/ .el-dialog__footer {
	border-top: 1px solid #e8e8e8;
	padding: 18px;
}

/deep/ .el-dialog__body .el-form-item__label {
	line-height: 26px;
}
</style>
